import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MKTypography
import MKTypographyRoot from "components/custom/MKTypography/MKTypographyRoot";

const MKTypography = forwardRef(
  (
    {
      // color,
      fontWeight,
      textTransform,
      verticalAlign,
      opacity,
      children,
      fontSize,
      ...rest
    },
    ref
  ) => (
    <MKTypographyRoot
      {...rest}
      ref={ref}
      ownerState={{
        // color,
        textTransform,
        verticalAlign,
        fontWeight,
        fontSize,
        opacity,
      }}
    >
      {children}
    </MKTypographyRoot>
  )
);

// Setting default values for the props of MKTypography
MKTypography.defaultProps = {
  // color: "dark",
  fontWeight: false,
  textTransform: "none",
  verticalAlign: "unset",
  opacity: 1,
};

// Typechecking props for the MKTypography
MKTypography.propTypes = {
  // color: PropTypes.oneOf([
  //   "inherit",
  //   "primary",
  //   "secondary",
  //   "info",
  //   "success",
  //   "warning",
  //   "error",
  //   "light",
  //   "dark",
  //   "text",
  //   "white",
  // ]),
  fontWeight: PropTypes.oneOf([
    false,
    "light",
    "regular",
    "medium",
    "bold",
    "extrabold",
  ]),
  textTransform: PropTypes.oneOf([
    "none",
    "capitalize",
    "uppercase",
    "lowercase",
  ]),
  verticalAlign: PropTypes.oneOf([
    "unset",
    "baseline",
    "sub",
    "super",
    "text-top",
    "text-bottom",
    "middle",
    "top",
    "bottom",
  ]),
  children: PropTypes.node,
  opacity: PropTypes.number,
};

export default MKTypography;
